import FormSwitch from './FormSwitch';
import { FormSwitchProps } from './types';

export type { FormSwitchProps };
export default FormSwitch;
